import { api } from '@/lib/axios';
import type { PieceJointe } from '@/services/achats';

export type Priorite = 'NORMALE' | 'HAUTE' | 'URGENTE';

export interface MessageInterne {
  id: string; expediteur_id: string; destinataire_id: string; objet: string; corps: string | null;
  priorite: Priorite; lu: boolean; date_envoi: string; parent_id: string | null; archive: boolean;
  pieces: PieceJointe[]; expediteur_nom: string | null; destinataire_nom: string | null;
}
export interface MessageInput {
  destinataire_id: string; objet: string; corps?: string | null; priorite?: Priorite; parent_id?: string | null;
}
export interface Conversation {
  interlocuteur_id: string; interlocuteur_nom: string | null; dernier_objet: string;
  dernier_corps: string | null; date_dernier: string; dernier_de_moi: boolean; non_lus: number;
}
export interface ConversationFil {
  interlocuteur_id: string; interlocuteur_nom: string | null; messages: MessageInterne[];
}

export async function listConversations(): Promise<Conversation[]> {
  const { data } = await api.get<Conversation[]>('/messagerie/conversations');
  return data;
}
export async function getConversation(interlocuteurId: string): Promise<ConversationFil> {
  const { data } = await api.get<ConversationFil>(`/messagerie/conversations/${interlocuteurId}`);
  return data;
}

export async function listRecus(q?: string): Promise<MessageInterne[]> {
  const { data } = await api.get<MessageInterne[]>('/messagerie/recus', { params: q ? { q } : {} });
  return data;
}
export async function listEnvoyes(q?: string): Promise<MessageInterne[]> {
  const { data } = await api.get<MessageInterne[]>('/messagerie/envoyes', { params: q ? { q } : {} });
  return data;
}
export async function getNonLus(): Promise<{ non_lus: number; urgents: number }> {
  const { data } = await api.get<{ non_lus: number; urgents: number }>('/messagerie/non-lus');
  return data;
}
export async function envoyer(payload: MessageInput): Promise<MessageInterne> {
  const { data } = await api.post<MessageInterne>('/messagerie', payload);
  return data;
}
export async function lireMessage(id: string): Promise<MessageInterne> {
  const { data } = await api.get<MessageInterne>(`/messagerie/${id}`);
  return data;
}
export async function archiverMessage(id: string): Promise<void> {
  await api.delete(`/messagerie/${id}`);
}
